import { render, staticRenderFns } from "./BaseFieldMessage.vue?vue&type=template&id=6351bf8a&"
import script from "./BaseFieldMessage.vue?vue&type=script&lang=ts&"
export * from "./BaseFieldMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports